import { ModelSagres } from "@/types/model-sagres"

export class ContaCaixa extends ModelSagres {
    IdPrestacaoConta: number
    CodigoBanco: string
    CodigoAgencia: string
    NumeroContBancaria: string
    NumeroContBancariaNovo: string | null
    TipoContBancaria: string
    DescricaoContBancaria: string
    TipoDestRecursos: string

    constructor(obj?: any) {
        super()
        if (obj.IdPrestacaoConta) this.IdPrestacaoConta = obj.IdPrestacaoConta
        if (obj.CodigoBanco) this.CodigoBanco = obj.CodigoBanco
        if (obj.CodigoAgencia) this.CodigoAgencia = obj.CodigoAgencia
        if (obj.NumeroContBancaria) this.NumeroContBancaria = obj.NumeroContBancaria
        if (obj.NumeroContBancariaNovo) this.NumeroContBancariaNovo = obj.NumeroContBancariaNovo
        if (obj.TipoContBancaria) this.TipoContBancaria = obj.TipoContBancaria
        if (obj.DescricaoContBancaria) this.DescricaoContBancaria = obj.DescricaoContBancaria
        if (obj.TipoDestRecursos) this.TipoDestRecursos = obj.TipoDestRecursos
    }
}